import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";

import useToggle from "../../Hooks/useToggle";
import useUser from "./useUser";
import InputSearchUser from "./InputSearchUser";
import useOnceEffect from "../../Hooks/useOnceEffect";
import { DATETIME_FORMAT } from "../../utils/Dates";

import "./admin.css";
import ModalEditRole from "./Util/ModalEditRole";

const AdminUserPeding = () => {
  const [modal, toggleModal] = useToggle(false);

  const userState = useUser();
  const { users, setUsers, user, setUser, getUsers } = userState;

  function aproveUser(id) {
    toast.success("en proceso, Aprobar", { duration: 3000 });

    axios
      .post(`user/update-profile-user/${id}/true`)
      .then(() => toast.success("Usuario aprobado", { duration: 3000 }));

    const old = users.filter((elm) => elm.userId !== id);
    setUsers(old);
  }

  function denyUser(id) {
    toast.success("en proceso, Denegar", { duration: 3000 });

    axios
      .post(`user/update-profile-user/${id}/false`)
      .then(() => toast.success("Usuario Rechazado", { duration: 3000 }));

    const old = users.filter((elm) => elm.id !== id);
    setUsers(old);
  }

  function changeRole(user) {
    setUser(user);
    toggleModal();
  }

  function saveRole(role) {
    if (!user) {
      toast.error("Usuario sin seleccionar");
      return;
    }

    const { userId } = user;

    axios
      .put("user/change-role", { userId, role })
      .then(() => {
        toast.success("Rol cambiado");
        getUsers();
        toggleModal();
      })
      .catch(() => {
        toast.error("No se pudo cambiar el rol del usuario");
      });
  }

  useOnceEffect(() => {
    let is_mounted = true;

    getUsers(is_mounted);

    return () => {
      is_mounted = false;
    };
  }, [getUsers]);

  return (
    <>
      <main id="admin" className="container mt-3">
        <InputSearchUser {...userState} />

        <table className="table">
          <thead>
            <tr>
              <th>Candidatos</th>
              <th>Correo</th>
              <th>Telefono</th>
              <th>Perfil</th>
              <th>Fecha de registro</th>
              <th>Estado</th>
            </tr>
          </thead>

          <tbody>
            {users.map((elm, i) => (
              <tr key={i}>
                <td className="py-3 px-3">
                  <div className="d-flex align-items-center">
                    <div>
                      <Avatar name={elm.name} />
                    </div>

                    <div> &nbsp; {elm.name}</div>
                  </div>
                </td>
                <td className="py-3">
                  <div className="d-flex align-items-center">{elm.email}</div>
                </td>

                <td className="py-3">
                  <div className="d-flex align-items-center">
                    {elm.telephone}
                  </div>
                </td>

                <td
                  className="py-3"
                  role="button"
                  onClick={() => changeRole(elm)}
                >
                  {" "}
                  {elm.roles[0]?.description ?? ""}{" "}
                  <i class="fas fa-pencil" style={{ color: "orange" }}></i>{" "}
                </td>
                <td>{moment(elm.fechaCreacion).format(DATETIME_FORMAT)}</td>
                <td className="py-3">
                  <div className="d-flex justify-content-between">
                    <button
                      onClick={() => aproveUser(elm.userId)}
                      className="btn-aprove"
                    >
                      Aprobar
                    </button>
                    <button
                      onClick={() => denyUser(elm.userId)}
                      className="btn-deny"
                    >
                      Denegar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>

      <ModalEditRole
        save={saveRole}
        show={modal}
        onClose={toggleModal}
        user={user}
      />
    </>
  );
};

export const Avatar = ({ name = "" }) => {
  return (
    <div className="avatar-custom mr-5">{name.split("")[0]?.toUpperCase()}</div>
  );
};

export default AdminUserPeding;
